import type { TFunction } from 'i18next';

import { z } from 'zod';

export const createLanguagesSchema = (t: TFunction) => {
  const languageSchema = z.object({
    language: z.string().min(1, t('Forms.Languages.errors.language')),
    level: z.string().min(1, t('Forms.Languages.errors.level')),
  });

  return z.object({
    languages: z
      .array(languageSchema)
      .min(1, t('Forms.Languages.errors.minLanguages'))
      .max(10, t('Forms.Languages.errors.maxLanguages')),
  });
};

export type LanguagesFormValues = z.infer<ReturnType<typeof createLanguagesSchema>>;
